import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c920ac28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "main-container" }
const _hoisted_3 = { class: "col edit-profile-area" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "EDIT PROFILE", -1))
const _hoisted_5 = { class: "edit-profile-form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fullname" }, "Name / Nickname*", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "current-password" }, "Current Password", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "new-password" }, "New Password", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "confirm-new-password" }, "(Confirm Password)", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "company" }, "Company", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Title", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Phone", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "interest" }, "Interest", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Education" }, "Education", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Site Maintenance" }, "Site Maintenance", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Others" }, "Others", -1))
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_20 = { class: "edit-profile-button" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Update", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cancel", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Delete Account", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", null, "Copyright © Augmented Knowledge 2023", -1))

import { useStore, type User } from "@/store";
import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { api } from "@/service/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditProfilePage',
  setup(__props) {

const router = useRouter();
const store = useStore();

const formData = reactive({
  displayName: "",
  email: "",
  curPassword: "",
  newPassword: "",
  company: "",
  title: "",
  phone: "",
  interest: "Others",
});

const confirmPassword = ref("");
const editProfileButtonEnabled = ref(true);

onMounted(async () => {
  const user = store.user;
  if (user === null) {
    router.push("/login");
    return;
  }

  const curProfileResponse = await api.get("/profile");

  if(curProfileResponse.status >= 400) {
    alert("Failed to get profile.");
    router.back();
    return;
  }

  const curProfile = curProfileResponse.data as User;

  formData.displayName = curProfile.displayName || "";
  formData.email = curProfile.email || "";
  formData.company = curProfile.company || "";
  formData.title = curProfile.title || "";
  formData.phone = curProfile.phone || "";
  formData.interest = curProfile.interest || "Others";
});

const cancel = () => {
  router.back();
};

const submit = async (event) => {
  event.preventDefault();

  const messages:string[] = [];
  if (formData.displayName?.trim().length < 3) {
    messages.push("Fullname must be longer than 3 characters.");
  }

  if (formData.newPassword?.trim().length < 8) {
    messages.push("Password must be longer than 8 characters.");
  }

  if (formData.newPassword !== confirmPassword.value) {
    messages.push("Password and Confirm password must be same.");
  }

  if (messages.length > 0) {
    alert(messages.reduce((a, m) => a + "- " + m + "\n", ""));
    return false;
  }

  const res = await api.put("/profile", formData);
  if (res.status < 400) {
    alert("Profile updated.");
    router.push("/");
  } else {
    alert("Failed to update profile.");
  }
};

async function deleteAccount(event) {
  event.preventDefault();

  const deleteConfirmPrompt = prompt("To delete your account, type DELETE in the box below.");
  if(deleteConfirmPrompt !== "DELETE") {
    return;
  }

  const res = await api.delete("/profile");
  if (res.status < 400) {
    alert("Account deleted.");
    router.push("/signout");
  } else {
    alert("Failed to delete account.");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("form", _hoisted_5, [
          _createElementVNode("p", null, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.displayName) = $event)),
              type: "text",
              name: "displayname",
              placeholder: "James Carter",
              required: ""
            }, null, 512), [
              [_vModelText, formData.displayName]
            ])
          ]),
          _createElementVNode("p", null, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              readonly: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.email) = $event)),
              type: "text",
              name: "email"
            }, null, 512), [
              [_vModelText, formData.email]
            ])
          ]),
          _createElementVNode("p", null, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.curPassword) = $event)),
              type: "password",
              name: "current-password",
              placeholder: "CURRENT PASSWORD",
              required: ""
            }, null, 512), [
              [_vModelText, formData.curPassword]
            ])
          ]),
          _createElementVNode("p", null, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.newPassword) = $event)),
              type: "password",
              name: "new-password",
              placeholder: "PASSWORD",
              required: ""
            }, null, 512), [
              [_vModelText, formData.newPassword]
            ])
          ]),
          _createElementVNode("p", null, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((confirmPassword).value = $event)),
              type: "password",
              name: "confirm-new-password",
              placeholder: "TYPE THE SAME ABOVE",
              required: ""
            }, null, 512), [
              [_vModelText, confirmPassword.value]
            ])
          ]),
          _createElementVNode("p", null, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.company) = $event)),
              type: "text",
              name: "company",
              placeholder: "Blue Sky Airline",
              required: ""
            }, null, 512), [
              [_vModelText, formData.company]
            ])
          ]),
          _createElementVNode("p", null, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.title) = $event)),
              type: "text",
              name: "title",
              placeholder: ""
            }, null, 512), [
              [_vModelText, formData.title]
            ])
          ]),
          _createElementVNode("p", null, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.phone) = $event)),
              type: "text",
              name: "phone",
              placeholder: ""
            }, null, 512), [
              [_vModelText, formData.phone]
            ])
          ]),
          _createElementVNode("p", null, [
            _hoisted_14,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.interest) = $event))
            }, _hoisted_18, 512), [
              [_vModelSelect, formData.interest]
            ])
          ]),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              class: _normalizeClass(["button confirm", { disabled: !editProfileButtonEnabled.value }]),
              onClick: submit
            }, _hoisted_22, 2),
            _createElementVNode("button", {
              class: "button cancel",
              onClick: cancel
            }, _hoisted_24)
          ]),
          _createElementVNode("div", { class: "delete-account-button" }, [
            _createElementVNode("button", {
              class: "button delete",
              onClick: deleteAccount
            }, _hoisted_26)
          ])
        ])
      ])
    ]),
    _hoisted_27
  ]))
}
}

})